// import { io } from "socket.io-client";

// const socket = io("https://api.krimotion.in", {
//   transports: ["websocket"],
// });

// export default socket;



import { io } from "socket.io-client";

const socket = io("https://api.krimotion.in", {
   transports: ["polling", "websocket"],
  reconnection: true
});

  socket.on("connect", () => {
    console.log("Socket connected:", socket.id);
  });

    socket.on("connect_error", (error) => {
    console.log("Socket connected:", error.message);
    
  });

export default socket;